import { ZCDCard } from '@zencity/common-ui';
import React, { ReactElement, useContext, useMemo } from 'react';
import { CardHeader } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/CardHeader/CardHeader';
import { ScoresList } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoresList';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { ReportBuilderWidgetProps } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { getParentDivision } from 'screens/WidgetGenerator/reportGeneratorComponents/helpers/division';

export const ScoresOverTimeByArea = (props: ReportBuilderWidgetProps): ReactElement | null => {
  const { params, clientData } = props;
  const { filters } = params;
  const { selectedSurveyGroup, selectedDateRange, cycles } = useContext(WidgetGeneratorContext);

  const parentDivisionId = useMemo(() => {
    const divisionTree = clientData.divisionTreeBySurveyType[selectedSurveyGroup.type];
    if (!filters?.division || !divisionTree) {
      return undefined;
    }
    const parentDivision = getParentDivision(filters.division, divisionTree);
    return parentDivision?.id;
  }, [filters?.division, selectedSurveyGroup.type, clientData.divisionTreeBySurveyType]);

  return (
    <ZCDCard
      header={
        <CardHeader
          surveyGroupId={selectedSurveyGroup.id}
          selectedDateRange={selectedDateRange}
          divisionId={filters?.division}
        />
      }
    >
      <ScoresList
        surveyGroupId={selectedSurveyGroup.id}
        selectedDateRange={selectedDateRange}
        cycles={cycles}
        divisionId={filters?.division}
        parentDivisionId={parentDivisionId}
      />
    </ZCDCard>
  );
};
